/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketTagItem } from '../../models/ticket-tag-item';
import { UpdateTicketTagDto } from '../../models/update-ticket-tag-dto';

export interface TicketControllerUpdateTicketTag$Params {
  id: number;
      body: UpdateTicketTagDto
}

export function ticketControllerUpdateTicketTag(http: HttpClient, rootUrl: string, params: TicketControllerUpdateTicketTag$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketTagItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerUpdateTicketTag.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketTagItem;
      }>;
    })
  );
}

ticketControllerUpdateTicketTag.PATH = '/ticket/tag/{id}';
